import { EventLite, LiveEventLite } from '@flocasts/flosports30-types/dist/watch'
import { getBadgeTextByEventStatus } from '../../events/functions/event-status'
import { LargeEventCardComponentProps } from './large-event-card.interfaces'
import { WatchListItemAnalytics } from '../../watch/utility/watch.interfaces'
import { LiveEventStatus } from '@flocasts/experience-service-types'
import { EventStatusComponentProps } from '../events/components/event-status/event-status.component'

/**
 * Utility function to map EventLite objects into the LargeEventCard display component.
 */
export const mapEventLiteToLargeEventCard = (
  event: EventLite,
  listItemAnalytics: WatchListItemAnalytics
): LargeEventCardComponentProps => {
  const eventStatusProps = !!event.live_event ? getEventStatusProps(event.live_event, event.number_of_days) : null

  return {
    type: event.type,
    displayTitle: event.short_title,
    showTopBadge: event.live_event?.status === 'LIVE',
    badgeText: getBadgeTextByEventStatus(event),
    destination: getEventCardDestination(event),
    drillThroughLink: event.drill_through_link,
    liveEventId: event.live_event?.id ?? null,
    imageThumbnailProps: {
      altText: event.short_title,
      imageSize: 720,
      mobileSize: 720,
      imageUrl: event.asset.url
    },
    eventStatusProps,
    tags: event.tags,
    analyticsProps: {
      ...listItemAnalytics,
      event_status: event.live_event?.status ?? null,
      node_id: event.id,
      node_type: event.type,
      primary_association_id: event.node.primary_event_or_series_association?.node_id ?? null,
      primary_association_title: event.node.primary_event_or_series_association?.title ?? null,
      is_premium: event.premium
    }
  }
}

/**
 * Return link to live event if it's Live or in Intermission, else link to event hub.
 */
const getEventCardDestination = (event: EventLite): string => {
  switch (event.live_event?.status) {
    case 'LIVE':
    case 'INTERMISSION':
      return !!event.live_event?.id ? `/live/${event.live_event?.id}` : event.slug_uri
    case 'PRE-AIR':
    case 'CONCLUDED':
    case 'INTERDAY':
    default:
      return event.slug_uri
  }
}

/**
 * Return props needed for FloEventStatus component.
 */
const getEventStatusProps = (liveEvent: LiveEventLite, numDays: number): EventStatusComponentProps => {
  return {
    status: liveEvent.status as LiveEventStatus,
    startAtNext: liveEvent.start_at_next,
    startDateTime: liveEvent.start_date_time,
    numberOfDays: numDays || null,
    startTimeTbd: liveEvent.start_time_tbd,
    shortPrint: false
  }
}
